import type { AuthUser, LoginResponse } from "@/types/auth.type";
import { api } from "./api";
import { AxiosError } from "axios";

/**
 * Connexion admin pour se connecter au backoffice
 * @param email - Email de l'admin
 * @param password - Mot de passe
 * @returns Informations de l'admin connecté
 */
export const loginAdmin = async (
  email: string,
  password: string
): Promise<LoginResponse> => {
  try {
    const response = await api.post<LoginResponse>("/auth/login", {
      email,
      password,
    });

    return response.data;
  } catch (error: unknown) {
    if (error instanceof AxiosError) {
      throw new Error(
        error.response?.data?.message || "Erreur lors de la connexion"
      );
    }
    throw new Error("Erreur de connexion au serveur");
  }
};

/**
 * Récupère le profil de l'utilisateur connecté grace au token via authenticateToken middleware
 * @returns 
 */
export const getCurrentUser = async () => {
  try {
    const response = await api.get<AuthUser>("/auth/me");
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw new Error(
        error.response?.data?.message || "Erreur lors de la récupération du profil"
      );
    }
    throw new Error("Erreur lors de la récupération du profil");
  }
};
